import useBRData from "./usebrdata";
import { useState, useEffect } from "react";

// This hook is a specialisation of the useBRData hook
// it only fetches data for the Team info
// Thjis is done to simjplify what is in the context, as the manipulation of the data happens here kkeeping it invisible in context and when using it.
// TYhis hook should return ONLY the data relevant to the team
const useTeam = (teamIds, accessKey) => {
  const [teamids, setTeamIds] = useState(teamIds);

  useEffect(() => {
    const t = teamIds.join(",");
    if (t !== teamids) {
      setTeamIds(t);
    }
  }, [teamIds]);

  const { data } = useBRData("t", { teamids: teamids }, accessKey);

  const teams = data.teams ?  
    Object.keys(data.teams).map((key) => {
      return data.teams[key];
    })
  : [];
 
  return { data: teams };
};

export default useTeam;
